'use client';

import { c as _c } from "react/compiler-runtime";
import type { ReactElement } from 'react';
import { styled } from '@classify/react-core-components/styles';
import { FormControlLabel } from '@mui/material';
import Callout from '@classify/react-core-components/Callout';
import { RichContent } from '@openclassrooms/rich-content';
const Root = styled('div')(({
  theme: {
    spacing
  }
}) => ({
  display: 'flex',
  flexDirection: 'column',
  '&:not(:last-child)': {
    marginBottom: spacing(1)
  }
}));
const StyledFormControlLabel = styled(FormControlLabel)({
  '&.Mui-disabled': {
    opacity: 0.8
  }
});
const ContentWrapper = styled(RichContent)(({
  theme: {
    breakpoints
  }
}) => ({
  '& p': {
    margin: `${0} !important`
  },
  '& pre': {
    margin: `${0} !important`,
    maxWidth: '98%',
    [breakpoints.up('sm')]: {
      maxWidth: '100%'
    },
    '& > code': {
      marginLeft: 0,
      marginRight: 0,
      marginTop: `${0} !important`,
      '&::before': {
        display: 'none'
      }
    },
    '& + p': {
      height: 0
    }
  }
}));
const CorrectContentWrapper = styled(ContentWrapper)(({
  theme: {
    typography
  }
}) => ({
  '& p': {
    fontWeight: `${typography.fontWeightBold} !important`
  }
}));
const Alert = styled(Callout)(({
  theme: {
    spacing
  }
}) => ({
  width: 'fit-content',
  margin: spacing(1, 0, 0, 4)
}));
interface Props {
  content: string;
  isCorrect?: boolean;
  control: ReactElement;
  isCompleted?: boolean;
  warningLabel?: string | null;
}
export default function AnswerWrapper(t0) {
  const $ = _c(12);
  const {
    content,
    isCorrect: t1,
    control,
    isCompleted: t2,
    warningLabel: t3
  } = t0;
  const isCorrect = t1 === undefined ? false : t1;
  const isCompleted = t2 === undefined ? false : t2;
  const warningLabel = t3 === undefined ? "" : t3;
  const Content = isCorrect ? CorrectContentWrapper : ContentWrapper;
  let t4;
  if ($[0] !== Content || $[1] !== content) {
    t4 = <Content content={content} />;
    $[0] = Content;
    $[1] = content;
    $[2] = t4;
  } else {
    t4 = $[2];
  }
  const t5 = isCompleted && !isCorrect;
  let t6;
  if ($[3] !== control || $[4] !== t4 || $[5] !== t5) {
    t6 = <StyledFormControlLabel label={t4} control={control} disabled={t5} />;
    $[3] = control;
    $[4] = t4;
    $[5] = t5;
    $[6] = t6;
  } else {
    t6 = $[6];
  }
  let t7;
  if ($[7] !== warningLabel) {
    t7 = warningLabel && <Alert type="warning">{warningLabel}</Alert>;
    $[7] = warningLabel;
    $[8] = t7;
  } else {
    t7 = $[8];
  }
  let t8;
  if ($[9] !== t6 || $[10] !== t7) {
    t8 = <Root>{t6}{t7}</Root>;
    $[9] = t6;
    $[10] = t7;
    $[11] = t8;
  } else {
    t8 = $[11];
  }
  return t8;
}